import * as Yup from 'yup';
import moment from 'moment';
import editExpressCheckinModel from './editExpressCheckingFormModel';
const {
  formField: {

    // DATOS AREA 
    e_code,
    e_adults,
    e_minors,
    e_arrival,
    e_departure
  }

} = editExpressCheckinModel;


export default [


  Yup.object().shape({ 
    [e_code.name]: Yup.string().required(`${e_code.requiredErrorMsg}`), 
    [e_adults.name]: Yup.number().required(`${e_adults.requiredErrorMsg}`), 
    [e_minors.name]: Yup.number().required(`${e_minors.requiredErrorMsg}`), 

    [e_arrival.name]: Yup.string().required(`${e_arrival.requiredErrorMsg}`),
    [e_departure.name]: Yup.string()
    .required(`${e_departure.requiredErrorMsg}`)
    .test(
      'is-after-arrival',
      ({ path }) => `La fecha de salida debe ser posterior a la fecha de llegada`, // Mensaje dinámico
      function(value) {
        const arrivalDate = this.parent[e_arrival.name];
        if (!arrivalDate || !value) return true;
        
        // Usa timestamps para mayor precisión
        return new Date(value).getTime() > new Date(arrivalDate).getTime();
      }
    ),

  })
  
];  

    